"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = redirectToSignalFactory;
function redirectToSignalFactory(signal, payload) {
  function redirectToSignal(_ref) {
    var router = _ref.router,
        resolve = _ref.resolve;

    router.redirectToSignal(resolve.value(signal), resolve.value(payload));
  }

  return redirectToSignal;
}
//# sourceMappingURL=redirectToSignal.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cerebral/router/lib/operators/redirectToSignal.js
// module id = 814
// module chunks = 1